import { useEffect } from 'react';
import PlansHero from '../components/plans/PlansHero';
import PlansGrid from '../components/plans/PlansGrid';
import PlansCTA from '../components/plans/PlansCTA';
import FAQ from '../components/FAQ';

export default function PlansPage() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" tabIndex={-1}>
      <PlansHero />
      <PlansGrid />

      <PlansCTA />
      <FAQ />
    </main>
  );
}
